__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "portalHost";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@okta/okta-react", "6.11.0", () => (Promise.all([__webpack_require__.e(1186), __webpack_require__.e(5774), __webpack_require__.e(6437), __webpack_require__.e(8816)]).then(() => (() => (__webpack_require__(96437))))));
			register("@playgami/portal-logs", "1.5.0", () => (__webpack_require__.e(9657).then(() => (() => (__webpack_require__(89657))))));
			register("@playgami/ui/sonner", "0.114.1", () => (Promise.all([__webpack_require__.e(9424), __webpack_require__.e(6567), __webpack_require__.e(3662), __webpack_require__.e(2553), __webpack_require__.e(3963), __webpack_require__.e(5193), __webpack_require__.e(387)]).then(() => (() => (__webpack_require__(10387))))));
			register("@playgami/ui/sonner", "0.114.1", () => (Promise.all([__webpack_require__.e(9424), __webpack_require__.e(6567), __webpack_require__.e(3662), __webpack_require__.e(2553), __webpack_require__.e(3963), __webpack_require__.e(5193), __webpack_require__.e(1072)]).then(() => (() => (__webpack_require__(21072))))));
			register("lodash", "4.18.1", () => (__webpack_require__.e(6537).then(() => (() => (__webpack_require__(86537))))));
			register("react-dom", "18.3.1", () => (() => (__webpack_require__(70316))), 1);
			register("react-redux", "9.2.0", () => (__webpack_require__.e(3828).then(() => (() => (__webpack_require__(3828))))));
			register("react-router-dom", "5.3.4", () => (Promise.all([__webpack_require__.e(7923), __webpack_require__.e(2975)]).then(() => (() => (__webpack_require__(47923))))));
			register("react", "18.3.1", () => (() => (__webpack_require__(22155))), 1);
			register("redux", "5.0.1", () => (() => (__webpack_require__(90805))), 1);
			initExternal(41499);
			initExternal(6079);
			initExternal(32436);
			initExternal(36878);
			initExternal(96308);
			initExternal(48048);
			initExternal(68595);
			initExternal(73107);
			initExternal(30009);
			initExternal(12651);
			initExternal(57177);
			initExternal(98257);
			initExternal(46203);
			initExternal(14738);
			initExternal(78334);
			initExternal(8250);
			initExternal(26579);
			initExternal(62536);
			initExternal(55731);
			initExternal(3140);
			initExternal(87093);
			initExternal(98104);
			initExternal(11175);
			initExternal(68923);
			initExternal(15780);
			initExternal(10055);
			initExternal(25343);
			initExternal(85738);
			initExternal(3072);
			initExternal(98714);
			initExternal(11632);
			initExternal(51274);
			initExternal(11211);
			initExternal(86784);
			initExternal(94493);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};